<div class="modal-header">
  <h4 class="modal-title">
    Add Text
    <span class="collection-tag">{{ collectionName }}</span>
  </h4>
  <button type="button" class="custom-close-btn" (click)="onCancel()" aria-label="Close">
    <img src="assets/icons/close-icon.svg" alt="close">
  </button>
</div>

<div class="modal-body">
  <p class="modal-description">
    Add a text to enhance the knowledge base of this collection.
  </p>

  <div class="form-group">
    <label for="chunkName" class="form-label">Heading</label>
    <input 
      type="text" 
      id="chunkName"
      class="form-control" 
      [(ngModel)]="chunkName"
      placeholder="Add Heading"
    >
  </div>

  <div class="form-group">
    <label for="chunkContent" class="form-label">Text</label>
    <textarea 
      id="chunkContent"
      class="form-control textarea-control" 
      [(ngModel)]="chunkContent"
      placeholder="Enter your main text here..."
      rows="6"
    ></textarea>
  </div>

<div class="modal-footer">
  <button type="button" class="btn btn-cancel" (click)="onCancel()">
    Cancel
  </button>
  <button 
    type="button" 
    class="btn btn-upload" 
    (click)="onUpload()"
    [disabled]="!chunkName.trim() || !chunkContent.trim() || isUploading">
    {{ isUploading ? 'Adding...' : 'Add' }}
  </button>
</div>
